import { render } from "./EventParticipationScoreRenderer.vue?vue&type=template&id=62a1e52d&ts=true"
import script from "./EventParticipationScoreRenderer.vue?vue&type=script&lang=ts"
export * from "./EventParticipationScoreRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__